import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const NetWorthChart = ({ data, projectionYears = 20 }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(value);
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="caption font-medium text-foreground mb-2">Année {label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4 mb-1">
              <span className="caption" style={{ color: entry?.color }}>
                {entry?.name}:
              </span>
              <span className="caption font-medium data-text" style={{ color: entry?.color }}>
                {formatCurrency(entry?.value)}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Graphique de valeur nette">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{ top: 5, right: 10, left: 10, bottom: 5 }}
        >
          <defs>
            <linearGradient id="colorNetWorth" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.4}/>
              <stop offset="95%" stopColor="#3b82f6" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis 
            dataKey="year" 
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '0.75rem', fontFamily: 'var(--font-caption)' }}
            label={{ value: 'Années', position: 'insideBottom', offset: -5, style: { fontSize: '0.75rem', fontFamily: 'var(--font-caption)' } }}
          />
          <YAxis 
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '0.75rem', fontFamily: 'var(--font-caption)' }}
            tickFormatter={(value) => `$${Math.round(value / 1000)}k`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Area 
            type="monotone" 
            dataKey="netWorth" 
            name="Valeur nette"
            stroke="#3b82f6" 
            strokeWidth={3}
            fillOpacity={1}
            fill="url(#colorNetWorth)"
            dot={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default NetWorthChart;
